export default __webpack_public_path__ + "static/media/disconnected-internet-cable.478dae85.svg";